import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var CarIcon = function CarIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "22",
    height: "19",
    viewBox: "0 0 22 19",
    fill: "none",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M21.0028 6.5L18.3828 7.5",
      stroke: "#693EB5",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M3.63 7.5L1 6.5",
      stroke: "#693EB5",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M17.25 11.5H14.75",
      stroke: "#693EB5",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.25 11.5H4.75",
      stroke: "#693EB5",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M18.377 7.5L17.538 3.488C17.295 2.33 16.274 1.5 15.09 1.5H7.01C5.849 1.5 4.84 2.3 4.576 3.431L3.625 7.5",
      stroke: "#693EB5",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2.25 17.5H4.5C5.328 17.5 6 16.828 6 16V15H16V16C16 16.828 16.672 17.5 17.5 17.5H19.75C20.44 17.5 21 16.94 21 16.25V10.5C21 8.843 19.657 7.5 18 7.5H4C2.343 7.5 1 8.843 1 10.5V16.25C1 16.94 1.56 17.5 2.25 17.5Z",
      stroke: "#693EB5",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};